import {useLocation, BrowserRouter} from "react-router-dom";
import Wrapper from "./components/Wrapper/Wrapper";
import Header from "./components/Header/Header";
import {AnimatePresence} from "framer-motion";
import {AppContext} from "./context/AppContext";
import Modal from "./components/SystemModal/Modal";
import FormController from "./components/FormController/FormController";
import AppRoutes from "./components/AppRoutes/AppRoutes";
import {useContext, useEffect, useState} from "react";
import {setModalCallback} from "./services/apiClient/apiClient";
import NotificationModal from "./components/NotificationModal/NotificationModal";
import {Toaster} from 'react-hot-toast';
import {useSelector} from "react-redux";

function AppContent() {
    const {isFormOpen} = useContext(AppContext);
    const {isModalOpen} = useSelector((state) => state.modal);
    const location = useLocation();
    const [notificationModalOpen, setNotificationModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");

    const showModal = (message) => {
        setModalMessage(message);
        setNotificationModalOpen(true);
    };

    const handleModalAction = () => {
        setNotificationModalOpen(false);
        location.href = "/login";
    };

    useEffect(() => {
        setModalCallback(showModal);

        return () => {
            setModalCallback(() => {
            });
        };
    }, []);

    return (
        <Wrapper>
            <Header/>
            <AnimatePresence>
                {isFormOpen && <FormController/>}
                {isModalOpen && <Modal/>}
                <NotificationModal
                    isOpen={notificationModalOpen}
                    message={modalMessage}
                    onAction={handleModalAction}
                    onClose={() => setNotificationModalOpen(false)}
                />
            </AnimatePresence>
            <AnimatePresence exitBeforeEnter>
                <AppRoutes/>
            </AnimatePresence>
            <Toaster
                position="top-right"
                reverseOrder={false}
                toastOptions={{
                    duration: 3000,
                    style: {
                        borderRadius: '10px',
                        background: 'var(--bg-form)',
                        color: 'var(--text-primary)',
                    },
                }}
            />
        </Wrapper>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AppContent/>
        </BrowserRouter>
    );
}

export default App;
